module.exports = __webpack_public_path__ + "static/media/mooveaze-gif.378b3355.gif";